export default {
  // Single-word names will no longer be used,
  // grandfathering this due current usage across the codebase
  name: 'Icon',
  description: 'A simple way to implement SVG icons.',
  functional: true,
  props: {
    height: {
      type: [Number, String]
    },
    src: {
      type: Object,
      required: true
    },
    width: {
      type: [Number, String]
    }
  },
  render (h, { props, data }) {
    if (!props.src || !props.src.viewBox) return

    const [x, y, width, height] = props.src.viewBox.split(' ')

    const dimensions = { h: Number(props.height || height), w: Number(props.width || width) }

    // Scale proportionally if either width or height are provided without the
    // paired property. This should behave the same as an `<img>` tag.
    if (props.width && !props.height) {
      dimensions.h = Math.round((height / width) * props.width)
    } else if (props.height && !props.width) {
      dimensions.w = Math.round((width / height) * props.height)
    }

    return h('svg', {
      class: data.class,
      attrs: {
        class: data.staticClass,
        height: dimensions.h,
        viewBox: [x, y, width, height].join(' '),
        width: dimensions.w
      }
    }, [h('use', { attrs: { 'xlink:href': '#' + props.src.id } })])
  }
}
